import React, { useRef, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styled from "styled-components";
import { Month } from "./Month";
import RevenueTable from "./RevenueTable";
import Today from "./Today";
import Week from "./Week";
import Year from "./Year";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactHtmlTableToExcel from "react-html-table-to-excel";

const Root = styled.div`
  margin: 40px 30px;
`;
const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;
const TextWrapper = styled.div``;
const Text = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: center;
`;

const FiltersContainer = styled.div`
  display: flex;
`;
const DateContainer = styled.div`
  margin: 0 10px;
  display: flex;
  justify-content:end;
  /* margin-right:30px; */
`;
const TabsContainer = styled.div`
  margin: 0 10px;
`;
const ExportContainer = styled.div`
position: relative;
`;
const Export = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  border: none;
  margin: 0px;
  outline: none;
  cursor: pointer;
`;

const ButtonWrapper = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
`;
const Button = styled.button`
  border: none;
  background-color: transparent;
  color: white;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  padding: 15px 15px;
  outline: none;
  cursor: pointer;
`;

const DatePickerWrapper = styled.div`
  width: 65%;
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  /* border: 1px solid #dddfe2; */
  /* margin: 0 20px; */
  position: relative;
`;

const DateCheckInInput = styled.div`
  position: absolute;
  top: 28%;
  right: 60%;
  font-size: 20px;
  cursor: pointer;
`;

const DateCheckOutInput = styled.div`
  position: absolute;
  top: 28%;
  right: 10%;
  font-size: 20px;
  cursor: pointer;
`;


const Span = styled.span`
position: absolute;
    top: 30%;
    right: 75%;
`;
const DatePickerWithInput = styled.div`
margin-right:10px;
`;




const DetailsFilter = () => {
  const [component, setCompotent] = useState(<Today />);
  const [selected, setSelected] = useState(0);
  const [open, setOpen] = useState(false);
  const InputCheckOut = useRef(null);
  const [checkIn, setCheckIn] = useState();
  const [checkOut, setCheckOut] = useState();
  const InputCheckIn = useRef(null);
  const [color, setColor] = useState([
    "rgba(255, 255, 255, 0.1)",
    "transparent",
    "transparent",
    "transparent",
  ]);
  function ClickHandler(event) {
    if (event === "Today") {
      setCompotent(<Today />);
      setSelected(0);
      setColor("transparent", [
        "rgba(255, 255, 255, 0.1)",
        "transparent",
        "transparent",
      ]);
    } else if (event === "Week") {
      setCompotent(<Week />);
      setSelected(1);
    } else if (event === "Month") {
      setCompotent(<Month />);
      setSelected(2);
      setColor("transparent", "transparent", [
        "rgba(255, 255, 255, 0.1)",
        "transparent",
      ]);
    } else {
      setCompotent(<Year />);
      setSelected(3);
      setColor("transparent", "transparent", "transparent", [
        "rgba(255, 255, 255, 0.1)",
      ]);
    }
  }

  const refHandle = () => {
    InputCheckOut.current.setOpen(true);
  };

  return (
    <Root>
      <Container>
        <TextWrapper>
          <Text>Details</Text>
        </TextWrapper>

        <FiltersContainer>
          <DateContainer>
            <DatePickerWrapper>
           <DatePickerWithInput>
           <DatePicker
                Icon
                placeholderText="From"
                selected={checkIn}
                onChange={(date) => setCheckIn(date)}
                ref={InputCheckIn}
                minDate={new Date()}
              ></DatePicker>
              <DateCheckInInput
                onClick={() => InputCheckIn.current.setOpen(true)}
              >
                <i class="fas fa-calendar-alt"></i>
              </DateCheckInInput>
           </DatePickerWithInput>
            <DatePickerWithInput>
            <DatePicker
                placeholderText="To"
                selected={checkOut}
                onChange={(date) => setCheckOut(date)}
                minDate={checkIn}
                ref={InputCheckOut}
              ></DatePicker>
              <DateCheckOutInput onClick={refHandle}>
                <i class="fas fa-calendar-alt"></i>
              </DateCheckOutInput>
            </DatePickerWithInput>
            </DatePickerWrapper>
          </DateContainer>
          <TabsContainer>
            <ButtonWrapper>
              <Button
                onClick={() => ClickHandler("Today")}
                style={{ background: color[0] }}
              >
                Today
              </Button>
              <Button
                onClick={() => ClickHandler("Week")}
                style={{ background: color[1] }}
              >
                Week
              </Button>
              <Button
                onClick={() => ClickHandler("Month")}
                style={{ background: color[2] }}
              >
                Month
              </Button>
              <Button
                onClick={() => ClickHandler("Year")}
                style={{ background: color[3] }}
              >
                Year
              </Button>
            </ButtonWrapper>
          </TabsContainer>
          <ExportContainer>
            <Export>
              <Span> <i class="fa-solid fa-upload"></i></Span> 
              <ReactHtmlTableToExcel 
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="table-to-xls"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Export"
              />
              </Export>

          </ExportContainer>
        </FiltersContainer>
      </Container>
      {/* <RevenueTable /> */}
      {component}
    </Root>
  );
};

export default DetailsFilter;
